import { useMemo } from 'react';
import { useQuery } from 'react-query';
import * as api from '../../services/api';

/**
 * Fetches Help Desk categories for all given branches in one request.
 * Returns categories grouped by branch for sectioned filter dropdowns.
 * @param {string} accountId
 * @param {Array<{ id: number, name: string }>} branches - from useBranches (admin's branches)
 */
const useHelpDeskCategoriesAllBranches = ({ accountId, branches = [] }) => {
  const branchIds = useMemo(() => branches.map((b) => b.id).filter(Boolean), [branches]);
  const branchIdsKey = useMemo(
    () =>
      branchIds
        .slice()
        .sort((a, b) => a - b)
        .join(','),
    [branchIds]
  );

  const { data, isLoading } = useQuery(
    ['helpDeskCategoriesAllBranches', accountId, branchIdsKey],
    () =>
      api.fetchHelpDeskCategoriesForBranches({
        accountId,
        branchIds,
        includeDeleted: false
      }),
    { enabled: !!accountId && branchIds.length > 0 }
  );

  const categoriesByBranch = useMemo(() => data?.data ?? {}, [data?.data]);

  return {
    categoriesByBranch,
    isLoading
  };
};

export default useHelpDeskCategoriesAllBranches;
